import React, {useState, useEffect} from 'react'
import { FaMapMarkerAlt, FaTemperatureHigh, FaWind } from 'react-icons/fa'
import { GiWaterDrop } from 'react-icons/gi'
import './WeatherStats.scss'
import useTranslation from '../useTranslation'

const WEATHER_POLL_INTERVAL = 300000

export default function Weather({ lineups, backgroundColor, foregroundColor }) {

    const [weather, setWeather] = useState(null)

    const WeatherStats = useTranslation('Weather Stats')

    // TODO: This call to the weather API should probably be moved to the backend and the weather info included in the data feed
    useEffect(() => {
        async function getWeather() {
            const { venue } = lineups || {};
            let { location  } = venue || {};
    
            let current = null;
    
            if (lineups && venue && location !== '(,)') {
                location = location.replace(/[()]/g, '')
                const response = await fetch(`https://api.weatherapi.com/v1/current.json?key=c0b3f1a253314a8a800132854211310&q=${location}&aqi=no`)
                const weather = await response.json()
                current = weather.current
            }
    
            setWeather(current)
        }

        getWeather()

        setTimeout(() => {
            getWeather()
        }, WEATHER_POLL_INTERVAL)
    }, [lineups])

    if (! lineups || ! lineups.venue || ! weather) {
        return null;
    }

    const { venue, host } = lineups.venue || {};

    const { condition, temp_c, wind_kph, precip_mm } = weather || {};

    const { text, icon } = condition || {};

    return (
        <>
            <div className="weather">
                <div className="weather-title" style={{
                    backgroundColor: foregroundColor,
                    color: backgroundColor
                }}>
                    {WeatherStats}
                </div>
                <div className="weather-inner">
                    { weather ? (
                        <div>
                            <img src={icon} alt={text}/> {text}
                        </div>
                    ) : null}

                    <div>
                        <FaMapMarkerAlt size={25} style={{ marginRight: 10 }}/>{venue}, {host}
                    </div>

                    <div>
                        <FaTemperatureHigh size={25} style={{ marginRight: 10 }}/>{temp_c} °C
                    </div>

                    <div>
                        <FaWind size={25} style={{ marginRight: 10 }}/>{wind_kph} km/h
                    </div>

                    <div>
                        <GiWaterDrop size={25} style={{ marginRight: 10 }}/>{precip_mm} mm
                    </div>
                </div>
            </div>
        </>
    )
}
